import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_DIM = 1800;

// Recompresse la photo dans le navigateur (photos iPhone HEIC incluses via createImageBitmap)
export const compressImage = async (file) => {
  const isImage = file.type?.startsWith("image/") || /\.(heic|heif)$/i.test(file.name || "");
  if (!isImage) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    if (bitmap.close) bitmap.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.82));
    if (!blob) return file;
    const name = `${(file.name || "photo").replace(/\.[^.]+$/, "")}.jpg`;
    return new File([blob], name, { type: "image/jpeg" });
  } catch (e) {
    return file;
  }
};

export const uploadPhoto = async (file, { onProgress, token } = {}) => {
  const prepared = await compressImage(file);
  const fd = new FormData();
  fd.append("file", prepared);
  const { data } = await axios.post(`${API}/media/upload`, fd, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
  return data;
};

export const mediaUrl = (id) => {
  const mt = localStorage.getItem("devisto_media_token");
  return `${API}/media/${id}${mt ? `?mt=${mt}` : ""}`;
};
